import React, { useMemo } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OutputManager } from './OutputManager';
import * as utils from '../../../../utils';
import { ToolTip } from '../../../../components';
import { useGetConfigQuery } from '../../../../store';

export const ProductManager = (props) => {
    const {
        productId,
        prodConfig,
        onSave,
        onDelete,
        onCopy,
        onBuildDoc,
        onBuildWorkflowDoc,
        opsDisable,
        opPhase,
    } = props;

    const [, setCpqData] = utils.cpqDataState.useStateContext();

    const configProdId = prodConfig ? prodConfig.idProduct : null;
    const { data: config } = useGetConfigQuery();

    const outputs = useMemo(() => {
        if (configProdId) {
            var entry;
            switch (configProdId) {
                case config?.configurators.ARTR:
                    entry = {
                        newDoc: false,
                        entry: config?.productDocuments.ARTR,
                    };
                    break;
                case config?.configurators.CIB:
                    entry = {
                        newDoc: true,
                        entry: config?.newProductDocuments.CIB,
                    };
                    break;
                case config?.configurators.CTB:
                    entry = {
                        newDoc: true,
                        entry: config?.newProductDocuments.CTB,
                    };
                    break;
                case config?.configurators.IsolatedInertiaBase:
                    entry = {
                        newDoc: true,
                        entry: config?.newProductDocuments.IsolatedInertiaBase,
                    };
                    break;
                case config?.configurators.PipeRiser:
                    entry = {
                        newDoc: false,
                        entry: config?.productDocuments.PipeRiser,
                    };
                    break;
                case config?.configurators.IsolatorSelection:
                    entry = {
                        newDoc: true,
                        entry: config?.newProductDocuments.IsolatorSelection,
                    };
                    break;
                case config?.configurators.LayInSolution:
                    entry = {
                        newDoc: true,
                        entry: config?.newProductDocuments.LayInSolution,
                    };
                    break;
                default:
            }
            return entry;
        }
        return null;
    }, [configProdId, config]);

    const isFullScreenProd = (configId) =>
        config?.fullScreenConfigurators.indexOf(configId, 0) >= 0;

    const renderToolTipIcon = (opsDisable) => {
        return (
            <button
                className={classNames(
                    'swegon-like-button white',
                    opsDisable ? 'text-gray-30' : '',
                )}
                title="Product options menu"
            >
                <FontAwesomeIcon icon="fa-solid fa-ellipsis" />
            </button>
        );
    };

    return (
        <ToolTip
            anchor={renderToolTipIcon(opsDisable)}
            place="right"
            noArrow="true"
            opsDisable={opsDisable}
            opPhase={opPhase}
        >
            <div className="divide-y-2 divide-solid">
                <ul>
                    {productId ? (
                        <li
                            className={classNames(
                                'mb-4',
                                opsDisable ? 'text-gray-30' : '',
                            )}
                        >
                            <button
                                onClick={() => {
                                    setCpqData({
                                        showModal: true,
                                        configuratorId: productId,
                                        onSubmit: onSave,
                                        fullScreen: isFullScreenProd(productId),
                                        configuredProduct: prodConfig,
                                    });
                                }}
                                disabled={opsDisable}
                                className={classNames(
                                    'swegon-like-button w-full text-left',
                                    opsDisable ? 'text-gray-30' : '',
                                )}
                            >
                                <FontAwesomeIcon
                                    className="mr-6"
                                    icon="fa-solid fa-pen"
                                />
                                Edit Product
                            </button>
                        </li>
                    ) : null}
                    <li
                        className={classNames(
                            'mb-4',
                            opsDisable ? 'text-gray-30' : '',
                        )}
                    >
                        <button
                            onClick={() => onCopy()}
                            disabled={opsDisable}
                            className={classNames(
                                'swegon-like-button w-full text-left',
                                opsDisable ? 'text-gray-30' : '',
                            )}
                        >
                            <FontAwesomeIcon
                                className="mr-6"
                                icon="fa-solid fa-copy"
                            />
                            Duplicate Product
                        </button>
                    </li>
                    <li
                        className={classNames(
                            'mb-2',
                            opsDisable ? 'text-gray-30' : '',
                        )}
                    >
                        <button
                            onClick={() => onDelete()}
                            disabled={opsDisable}
                            className={classNames(
                                'swegon-like-button w-full text-left',
                                opsDisable ? 'text-gray-30' : '',
                            )}
                        >
                            <FontAwesomeIcon
                                className="mr-6"
                                icon="fa-solid fa-trash-can"
                            />
                            Delete Product
                        </button>
                    </li>
                </ul>
                {outputs ? (
                    <ul>
                        <OutputManager
                            menu={outputs}
                            onBuildDoc={onBuildDoc}
                            onBuildWorkflowDoc={onBuildWorkflowDoc}
                            opsDisable={opsDisable}
                        />
                    </ul>
                ) : null}
            </div>
        </ToolTip>
    );
};
